import { ILearnisticApp, ILearnisticTag } from "../generated/Api";

export function LearnisticAppsToTags(
  learnisticApps: ILearnisticApp[],
  learnisticAppsPool?: ILearnisticApp[]
) {
  let learnisticTags: ILearnisticTag[] = [];

  if (!learnisticAppsPool) {
    learnisticApps.forEach((app) => {
      learnisticTags = [...learnisticTags, ...app.tags];
    });
  } else {
    learnisticApps.forEach((app) => {
      const appsFromPool = learnisticAppsPool.find(
        (appFromPool) => appFromPool.vAppId === app.vAppId
      );

      if (appsFromPool) {
        learnisticTags = [
          ...learnisticTags,
          ...appsFromPool.tags.filter((t) =>
            app.tags.find((tg) => tg.id === t.id)
          ),
        ];
      }
    });
  }

  return learnisticTags;
}

export function LearnistiTagsToApps(
  allLearnisticApps: ILearnisticApp[],
  learnisticTags: ILearnisticTag[]
) {
  const filteredApps: ILearnisticApp[] = allLearnisticApps
    .map((app) => ({
      ...app,
      tags: app.tags.filter(
        (t) =>
          !!learnisticTags.find((tg) => tg.name === t.name && tg.id === t.id)
      ),
    }))
    .filter((newApps) => newApps.tags.length > 0);

  return filteredApps;
}
